import * as React from 'react'
import Layout from '../components/layout'
import ContentMargins from '../components/ContentMargins'
import {css} from '@emotion/core'
import { ContactForm } from '../components/ContactForm'
import { Link } from '../components/Link'


export const ContactPage = () => (
  <Layout>
    <ContentMargins style={{marginBottom: 40}}>
      <h1 style={{marginBottom: '2em', fontSize: '40px', fontWeight: 900}}>So kommen Sie mit uns in Kontakt.</h1>

      <ContactOption number={1} title={<>
        Per Telefon
      </>}>
        <p css={css`
          display: block;
          font-size: 20px;
          font-weight: 100;
          margin: 0 0 30px;
        `}>
          Wir sind erreichbar während unserer <Link to={"/öffnungszeiten"}>Öffnungszeiten</Link>.
        </p>

        <div>
          <PhoneIcon width={'1.5em'} height={"1.5em"} />
          <span style={{fontWeight: "bold"}}>089 365947</span>
          <span style={{color: 'gray', paddingLeft: '10px'}}>Innerhalb Deutschlands</span>
        </div>

        <div>
          <PhoneIcon width={'1.5em'} height={"1.5em"} />
          <span style={{fontWeight: "bold"}}>+49 (0)89 365947</span>
          <span style={{color: 'gray', paddingLeft: '10px'}}>International</span>
        </div>

        <Hint>
          Sie wollen ein Fax schicken? <span style={{fontWeight: "bold"}}>089 36102315</span>
        </Hint>
      </ContactOption>
      <ContactOption number={2} title={"Kontaktformular"}>
        <ContactForm />

        <Hint>
          Sie können uns auch direkt eine E-Mail schicken, an: {" "}
          <a href={"mailto:blumen@elsdoerfer.com"} style={{color: '#9b1030'}}><strong>blumen@elsdoerfer.com</strong></a>
        </Hint>
      </ContactOption>

      <div style={{marginTop: '80px', borderTop: '1px solid gray', paddingTop: '80px'}}>
        <div style={{marginLeft: '80px'}}>
          <em>Brauchen sie unsere Postanschrift? Schreiben Sie an unser Ladengeschäft:</em>

          <div style={{
            marginTop: '1em'
          }}>
            Blumen Elsdörfer<br/>
            Ungererstraße 157<br/>
            80805 München<br/>
          </div>
        </div>
      </div>
    </ContentMargins>
  </Layout>
)

export default ContactPage;


function TelefonNumer() {

}


function Hint(props: {children?: any}) {
  return <p style={{fontStyle: 'italic', fontSize: '.9em', marginTop: '2em'}}>
    {props.children}
  </p>
}


function BigNumber(props: {number: number}) {
  return <div css={css`  
    border-radius: 50%;
    width: 60px;
    height: 60px;
    
    background: #607d8b;
    font-size: 50px;
    font-weight: 900;
    
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;    
  `}>
    {props.number}
  </div>
}


function ContactOption(props: {
  number: number,
  title: any,
  children: any,
}) {
  return <div css={css`
    display: grid;
    grid-template-columns: fit-content(40px) 1fr;
    grid-column-gap: 25px;
    margin-bottom: 40px;
    
    & .title {
      grid-row: 1;
      grid-column: 2;
      
      font-size: 26px;
      margin: 0;
      align-self: center;
    }
    
    & .content {
      grid-row: 2;
      grid-column: 2;
      font-size: 20px;
    }
  `}>
    <BigNumber number={props.number} />
    <h3  className={"title"}>
      {props.title}
    </h3>
    <div className={"content"}>
      {props.children}
    </div>
  </div>
}


const PhoneIcon = (props: any) => (
  <svg width="1em" height="1em" viewBox="0 0 512 512" {...props}>
    <path
      fill="#FEBF10"
      d="M268 270.2c-2.2-2.7-5.9-6.9-9.5-7.5-5.5-.9-8.7 6.5-10.6 11.8 2.6 0 5.2 0 7.8-.1 3.9-.2 10 0 13.4-2.4-.3-.5-.8-1.4-1.1-1.8z"
    />
    <path
      fill="#D6E5E5"
      d="M307.6 125.1c-6.1-6.3-13.3-10.4-22.1-11-14.8-.9-29.4 1.5-44 3.1-12.3 1.3-24.7.4-37 1.8-10.3 1.1-20.2 4.2-25.2 13.7v.3c0 18.4.1 37.9 3.5 56 3.1 16.1 11 31.9 27.9 36.8 14.4 4.2 30.7 4.5 45.5 3.9 15.7-.6 33.1-2.5 47-10.5 15.3-8.8 21.3-24.7 21.4-41.9.1-17.8-4.3-38.8-17-52.2z"
    />
    <path
      fill="#FEBF10"
      d="M215.5 447c-3.1-6.5-17.9-10-18.2 0-.1 2.4-1.6 4.1-3.4 4.8 1.8 5.5 6.7 10.4 12.6 9.6 6.2-.8 11.9-8.3 9-14.4zm49-107.9c-8.1 1-13.8 7.8-13.2 15.9.3 12.9 22.4 4.6 24.6-3.9 1.8-7-4.5-12.9-11.4-12zm9.3 50.9c-6.5.3-16.6 3.7-12.8 11.8.9 2.1.4 3.8-.8 4.9 1.2 1.8 3.2 2.9 6.3 2.8 5.4-.2 11.9-2.7 14.4-7.9 2.6-5.7-.6-11.9-7.1-11.6zm-26.7-89.6c0 5.7 1.9 12.1 7.2 14.9 4.9 2.5 10 2.2 14.9.7v-15.5h-22.1zm96.8-260c-4.7 0-9.4.1-14 .5-3.6.3-13 .1-15.5 3.3-.9 1.1-.6 4.7-.5 6.3.1 3.1.4 6.2.8 9.3 8.4-3.3 17.8-3.5 26-7.1 2.1-.9 3.8-.3 5 .9l-1.8-13.2zM209.3 402.8c-.4-4.5-3.9-8.8-8.8-8.4-5.7.5-5.9 6-5.2 10.6.6 3.7-2.5 5.5-5.4 5.1 6.1 5.7 20.2 2.6 19.4-7.3zm131.9-13.3c-1.2-7.8-10.4-10.3-16-5.5-3.4 2.9-5.4 7.2-5.6 11.4.6.5 1.2 1.3 1.5 2.3 1.9 5.8 6.3 8.8 12 5.4 4.4-2.7 8.9-7.9 8.1-13.6z"
    />
    <path
      fill="#F6851F"
      d="M203.4 274.6c-3.4-1.8-8.3-3.8-12-2.5-3.2 1.2-2.9 5.1-2.2 8.9.9 4.7-4.5 6.3-7.7 4.2-.1.1-.3.2-.5.4-1.1.7-1.1.7-1.3 2.4-.1.8.5 3.2 1 4.7 1.7 4.2 4.5 8.1 7.8 11.1 6.6 6 16.5 10.1 21.7.2 5.9-10.9 4.8-23.1-6.8-29.4z"
    />
    <path
      fill="#FEBF10"
      d="M201 348.1c-6.9 1.2-12.4 8-11.7 14.9.2 1.8-.5 3.1-1.5 4 6.7 3.5 18.6-.5 21.7-6.9 2.6-5.6-1.9-13.1-8.5-12zm77 92.1c-3.4 1.1-8.1 4.1-8.2 7.6 1 .8 1.6 2 1.5 3.5l.3.3c2.5 2.3 1.8 5.6-.1 7.4.9 1.9 2.7 2.9 5.9 2.6 4.8-.5 10.3-3.8 11.3-8.9 1.1-6.2-3.2-14.8-10.7-12.5z"
    />
    <path
      fill="#EF4823"
      d="M324.7 258.5c-3.8-.7-8.4-2.5-10.8 1.7-2.2 3.8-3.4 8-4.7 12.1-.4 9.6-1.3 22.8 9.2 26.7 9 3.3 14.1-12.5 15-18.6 1.1-7.6 1.2-20.1-8.7-21.9z"
    />
    <path
      fill="#FEBF10"
      d="M335 344.3c-1.6-4.9-6.4-8.3-11.6-7.9-6.1.4-8.5 4.8-8.1 10.6.1 1.3-.3 2.4-.8 3.2 3.1 4.5 8.4 8 14.1 7.1 5.8-.9 8.1-7.7 6.4-13zm-.6 90.8c-4.8-1.7-20.4 2.2-16 9.5 1.3 2.2.8 4.4-.5 5.9 1.3 4.6 4.2 7.8 9.6 6.8 5.3-1 10.8-5.3 13.1-10.1 2.6-5.5-.3-10.1-6.2-12.1z"
    />
    <path
      fill="#3AB37C"
      d="M368.7 357.8c-.9-16.4-2.6-32.7-4.2-49-2.4-25.3-3.6-50.7-5.1-76-3.3-57.7-6.3-115.4-13.2-172.8-.5.9-1.3 1.7-2.4 2.2-8.8 4-19.1 3.8-28 8-.1.1-.2.1-.3.1.2 3.4.1 6.8-.4 10.1-.6 3.5-4.2 4.5-7.1 3.5-14.2-4.9-29.4-5.1-44.4-5-13.7.1-27.1 1.7-40.8 2.4-22.1 1.1-46.8 2-61.2 21.5-12.1 16.3-13.6 38.5-13.5 58.1.1 22.6 1 45.2 1.3 67.8.8 56.8 3.8 113.6 3.8 170.4 0 1.1-.3 2-.7 2.7 5.6 9.7 3.6 22.5 4.2 33.4.6 11.6 2.6 24.4 11.4 32.8 9.3 8.9 22.5 12.4 34.7 15.5 15.3 3.9 31 5.6 46.8 6 13.4.3 26.9 0 40.3-1 10.5-.7 21.7-.9 31.9-3.9 14.4-4.2 26-13.5 33.3-26.6 16.3-29.8 15.5-67.4 13.6-100.2zm-18.1 28.1c2.3 10.7-3.8 21.4-13.4 26.2-6.4 3.2-12.6 2.9-17.5-.2-1.9.5-4 .2-5.5-1.7-8.5-10.6-4.8-27.5 6.2-35 10.5-7.3 27.2-2.8 30.2 10.7zM179.8 357c2.3-9.9 11-18.7 21.4-19 12.1-.4 21.8 11.3 18.5 23.2-2.8 10.1-14 16.4-24 16.9-11.2.6-20.1-5.2-22.4-16.3-.9-4.2 3.2-5.9 6.5-4.8zm-4.3-79.7c1.1-.8 2.3-1 3.3-.8 0-1.6.3-3.2.8-4.8 4.9-15 24.3-10.1 33.5-2.5 13.3 11 14.6 31.2 2.8 44.2-21 23.3-61.6-21.9-40.4-36.1zm1.8 128.5c-.7-4.7 4.6-6.3 7.7-4.3.3-8.7 5.4-17.3 15.4-17 10 .3 19.2 8 18.9 18.6-.8 24.1-38.5 27-42 2.7zm27.8 65.6c-13.9-.3-22.9-14-21.7-27 .3-3.2 2.9-4.3 5.4-3.8 2.7-6.6 9-10.4 17.2-9.8 9.2.7 18 6.9 19.9 16.2 2.5 12.2-8.6 24.7-20.8 24.4zm6.2-235.1c-19.8-5.2-32.3-19.9-37-39.5-4.9-20.3-5-42.2-5-63 0-.4.1-.9.1-1.3-.3-1-.2-2.1.4-3.4 3.4-7.3 9.2-12.9 16.6-16 9.9-4.2 21-4.7 31.6-4.7 13.9 0 27.4-1.9 41.2-3.3 12.3-1.2 26.3-2.8 38.2 1.3 8.2 2.9 15.1 8.5 20.3 15.3 11.5 14.9 17 35 16.9 53.6-.1 17.2-4.5 35.6-18.4 46.9-14.3 11.7-34.1 15.7-52.2 17-9.7.7-19.3.6-29 0-7.7-.4-16.1-.9-23.7-2.9zm26.2 38.7c0-.6.1-1.2.3-1.8 3.1-9 9.7-22.5 21.5-20.5 8.3 1.4 20.6 11.2 19.8 20.7-.6 7.6-10.1 9.7-16.2 10.4-7.4.9-14.8.6-22.2.6-5.5 0-6.9-7.3-3.2-9.4zm-.1 21.4c.2-2 1.2-3.1 2.5-3.6.6-1.4 2-2.4 4-2.4h30c2.6 0 5.4 1.7 5.4 4.6v24c0 2.4-1.1 4.2-3.3 5.1-9.3 3.9-20.5 4.6-28.9-1.8-8.3-6.1-10.5-16.1-9.7-25.9zm3.9 59.4c-1-13.2 8.9-25.6 22.4-26.7 12.2-1 25 9.2 22.3 22.4-4 19.8-44 30.7-44.7 4.3zm8.1 40.6c.2-1.2.7-2.1 1.4-2.7 2.9-8.2 13.1-13.7 22.3-13.7 6.2 0 12.6 1.6 15.8 7.4 2.9 5.2 3.7 11.1 1.7 16.8-3.5 9.7-14.8 15.6-24.7 15.2-12.9-.5-18.7-11.1-16.5-23zm28 75.3c-11.3.2-17.4-8-16.5-18.3-3.6-8.9 3-19.3 12.9-22.4 13.5-4.2 25.3 6 24.9 19.9-.2 11.2-10.2 20.6-21.3 20.8zM299.2 273c-.2-.7-.2-1.4 0-2.3v-1c0-1.5.6-2.7 1.4-3.5 1.6-5.2 3.5-10.6 7.3-14.5 5.1-5.1 12.1-4.6 18.6-3 15 3.7 18.9 18.7 16.8 32.4-1.8 11.6-10.6 32-26 28-7.5-1.9-14-8-16.4-15.4-2.1-6.8-1.8-13.7-1.7-20.7zm6 72.5c.3-9.9 6.5-18.8 17.3-19.1 10.5-.3 20.2 6.1 22.4 16.7 2.2 10.9-3.8 23-15.7 24.2-11.4 1.1-21-6.3-25.7-16.3-1.1-2.4-.1-4.5 1.7-5.5zM351 447.9c-2.9 9.8-12.7 17.8-22.7 19.4-12.6 1.9-19.6-8.2-21-19.4-.2-1.3.1-2.3.6-3.1-2.3-12.1 13-20.8 24.8-19.9 11.5.6 21.8 11.2 18.3 23z"
    />
    <path
      fill="#010101"
      d="M373.8 299.8c-3.7-42.2-5.1-84.6-7.7-126.9-2.8-46.1-6.5-92.1-12.8-137.9-.4-2.9-2.5-4.6-5.4-4.6-7.1 0-14.2.1-21.2.8-6.3.6-14.6 1.3-19.3 6-4.4 4.4-3.6 12-3.2 17.7.4 5.8 1.7 11.9 1.7 17.9-4-1.2-8-2-12.5-2.5-8.2-.8-16.4-1.2-24.6-1.4-15.1-.3-30 1.4-45 2.2-24.5 1.4-49.8 2.6-67.3 22.2-13.7 15.3-17 36.9-18 56.7-1 21.2.8 42.5.9 63.8.3 61.2 3.8 122.4 4 183.7-1.8 1.9-2.6 5.1-.3 7.6 3 3.3 3.2 8.9 3.5 13.1.4 5.9.1 11.7.3 17.6.4 10.4 2.4 20.8 7.3 30 10 18.6 33.5 24.5 52.5 28.8 25.8 5.8 53 5.6 79.3 4.1 19.3-1.1 39.6-1.8 56.4-12.5 28.1-17.9 35-55.2 36.7-85.9 1.8-33.7-2.4-67.1-5.3-100.5zM314.4 44.2c2.5-3.2 11.9-3 15.5-3.3 4.7-.4 9.3-.5 14-.5.6 4.4 1.2 8.8 1.7 13.2-1.1-1.3-2.9-1.8-5-.9-8.2 3.7-17.6 3.8-26 7.1-.3-3.1-.6-6.2-.8-9.3 0-1.5-.3-5.1.6-6.3zM355 457.9c-7.3 13.1-18.9 22.4-33.3 26.6-10.2 3-21.4 3.2-31.9 3.9-13.4.9-26.8 1.3-40.3 1-15.7-.4-31.5-2.1-46.8-6-12.2-3.1-25.3-6.6-34.7-15.5-8.8-8.4-10.8-21.2-11.4-32.8-.6-10.9 1.4-23.6-4.2-33.4.4-.7.7-1.6.7-2.7 0-56.8-3-113.6-3.8-170.4-.3-22.6-1.2-45.2-1.3-67.8-.1-19.6 1.4-41.8 13.5-58.1 14.4-19.5 39.1-20.4 61.2-21.5 13.6-.7 27.1-2.3 40.8-2.4 14.9-.1 30.2.1 44.4 5 3 1 6.5 0 7.1-3.5.6-3.3.6-6.7.4-10.1.1 0 .2-.1.3-.1 8.9-4.2 19.2-4 28-8 1.1-.5 1.9-1.3 2.4-2.2 6.8 57.4 9.9 115.1 13.2 172.8 1.4 25.3 2.7 50.7 5.1 76 1.6 16.3 3.2 32.6 4.2 49 2 32.9 2.8 70.5-13.6 100.2z"
    />
    <path
      fill="#010101"
      d="M317.7 121.7c-5.3-6.8-12.2-12.4-20.3-15.3-11.9-4.2-25.9-2.6-38.2-1.3-13.8 1.4-27.3 3.3-41.2 3.3-10.6 0-21.7.5-31.6 4.7-7.4 3.2-13.2 8.8-16.6 16-.6 1.2-.6 2.3-.4 3.4-.1.4-.1.8-.1 1.3 0 20.8.2 42.7 5 63 4.7 19.6 17.2 34.3 37 39.5 7.6 2 16 2.5 23.8 3 9.7.6 19.3.7 29 0 18-1.3 37.8-5.2 52.2-17 13.9-11.4 18.3-29.7 18.4-46.9 0-18.7-5.4-38.8-17-53.7zm-14.5 97.5c-13.9 8-31.2 9.9-47 10.5-14.8.6-31.2.2-45.5-3.9-16.9-4.9-24.8-20.6-27.9-36.8-3.4-18.2-3.5-37.6-3.5-56v-.3c5-9.5 14.9-12.6 25.2-13.7 12.3-1.3 24.7-.5 37-1.8 14.6-1.5 29.2-3.9 44-3.1 8.9.5 16.1 4.6 22.1 11 12.7 13.3 17.2 34.3 17 52.2-.1 17.1-6.1 33-21.4 41.9zm-90.1 50c-9.2-7.7-28.6-12.5-33.5 2.5-.5 1.5-.7 3.2-.8 4.8-1-.1-2.2.1-3.3.8-21.2 14.3 19.4 59.5 40.5 36.1 11.7-13.1 10.4-33.2-2.9-44.2zm-2.8 34.8c-5.3 9.9-15.1 5.8-21.7-.2-3.3-3.1-6.1-6.9-7.8-11.1-.6-1.4-1.1-3.8-1-4.7.1-1.7.2-1.7 1.3-2.4.2-.1.3-.2.5-.4 3.3 2.1 8.6.6 7.7-4.2-.7-3.8-1-7.7 2.2-8.9 3.7-1.4 8.6.6 12 2.5 11.5 6.3 12.6 18.5 6.8 29.4zm116.3-55.3c-6.4-1.6-13.5-2.1-18.6 3-3.9 3.9-5.7 9.3-7.3 14.5-.8.9-1.4 2-1.4 3.5v1c-.2.8-.2 1.6 0 2.3-.2 7-.4 13.9 1.8 20.7 2.4 7.4 8.9 13.5 16.4 15.4 15.4 4 24.2-16.4 26-28 2-13.7-1.9-28.7-16.9-32.4zm6.8 31.7c-.9 6.1-6 21.9-15 18.6-10.5-3.8-9.6-17-9.2-26.7 1.4-4.1 2.6-8.3 4.7-12.1 2.4-4.2 7-2.4 10.8-1.7 9.9 1.8 9.8 14.3 8.7 21.9zm-74.1-27.7c-11.8-2-18.4 11.4-21.5 20.5-.2.6-.3 1.2-.3 1.8-3.7 2.1-2.3 9.4 3.2 9.4 7.4 0 14.8.3 22.2-.6 6.1-.7 15.6-2.8 16.2-10.4.8-9.5-11.5-19.3-19.8-20.7zm-3.6 21.6c-2.6.1-5.2.2-7.8.1 1.9-5.3 5.2-12.7 10.6-11.8 3.6.6 7.3 4.8 9.5 7.5.3.4.9 1.2 1.1 1.7-3.5 2.5-9.5 2.3-13.4 2.5zm18.2 16.1h-30c-2 0-3.4 1-4 2.4-1.3.5-2.4 1.7-2.5 3.6-.8 9.8 1.5 19.7 9.7 25.9 8.4 6.3 19.6 5.7 28.9 1.8 2.2-.9 3.3-2.7 3.3-5.1v-24c0-2.9-2.9-4.6-5.4-4.6zm-4.6 25.5c-5 1.5-10.1 1.8-14.9-.7-5.4-2.8-7.3-9.1-7.2-14.9h22.2v15.6zM201.2 338c-10.4.4-19.1 9.2-21.4 19-3.2-1.2-7.4.5-6.5 4.7 2.3 11.2 11.2 16.9 22.4 16.3 10-.5 21.2-6.8 24-16.9 3.3-11.8-6.4-23.5-18.5-23.1zm8.2 22.1c-3.1 6.4-14.9 10.3-21.7 6.9 1-.9 1.7-2.2 1.5-4-.6-6.9 4.8-13.8 11.7-14.9 6.7-1.1 11.2 6.4 8.5 12zm54.3-31c-13.5 1.1-23.4 13.5-22.4 26.7.7 26.4 40.8 15.5 44.7-4.3 2.7-13.2-10.1-23.4-22.3-22.4zm12.2 22c-2.2 8.5-24.3 16.9-24.6 3.9-.6-8.1 5.1-14.9 13.2-15.9 6.9-.9 13.2 5 11.4 12zm69-8c-2.1-10.6-11.9-17-22.4-16.7-10.8.3-17.1 9.2-17.3 19.1-1.8 1-2.9 3.1-1.7 5.6 4.7 9.9 14.3 17.4 25.7 16.3 11.9-1.2 17.9-13.3 15.7-24.3zm-16.4 14.2c-5.6.9-10.9-2.6-14.1-7.1.6-.8.9-1.9.8-3.2-.4-5.8 2-10.2 8.1-10.6 5.2-.4 10 3 11.6 7.9 1.8 5.3-.5 12.1-6.4 13zm-128.1 27.1c-10-.3-15.1 8.3-15.4 17-3.2-2-8.4-.4-7.7 4.3 3.5 24.3 41.2 21.5 42-2.8.3-10.5-8.9-18.2-18.9-18.5zm-10.5 25.7c2.9.3 5.9-1.5 5.4-5.1-.7-4.6-.5-10.1 5.2-10.6 5-.4 8.4 3.9 8.8 8.4.8 9.9-13.3 13-19.4 7.3zm99-22.7c-3.2-5.8-9.6-7.4-15.8-7.4-9.2 0-19.4 5.5-22.3 13.7-.7.6-1.2 1.5-1.4 2.7-2.2 11.9 3.7 22.5 16.5 23 9.9.4 21.2-5.6 24.7-15.2 2-5.7 1.2-11.6-1.7-16.8zm-8.1 14.2c-2.5 5.2-9 7.7-14.4 7.9-3.1.1-5.1-1-6.3-2.8 1.2-1.1 1.8-2.9.8-4.9-3.7-8.1 6.4-11.5 12.8-11.8 6.6-.3 9.8 5.9 7.1 11.6zm69.8-15.7c-2.9-13.5-19.7-18-30.2-10.8-11 7.5-14.7 24.4-6.2 35 1.5 1.9 3.7 2.3 5.5 1.7 4.9 3.1 11.2 3.4 17.5.2 9.6-4.7 15.7-15.4 13.4-26.1zM333 403.1c-5.7 3.5-10.1.4-12-5.4-.3-1-.9-1.7-1.5-2.3.2-4.3 2.2-8.5 5.6-11.4 5.6-4.8 14.8-2.3 16 5.5.9 5.7-3.6 10.9-8.1 13.6zm-107.1 44c-1.9-9.3-10.8-15.5-19.9-16.2-8.2-.6-14.5 3.2-17.2 9.8-2.5-.5-5.1.6-5.4 3.8-1.2 12.9 7.8 26.6 21.7 27 12.2.2 23.3-12.3 20.8-24.4zm-19.4 14.3c-5.9.8-10.8-4.1-12.6-9.6 1.8-.7 3.3-2.3 3.4-4.8.3-10 15.1-6.6 18.2 0 2.9 6.1-2.8 13.6-9 14.4zm67.4-30.3c-10 3.1-16.6 13.5-12.9 22.4-.9 10.2 5.2 18.5 16.5 18.3 11-.2 21.1-9.6 21.4-20.7.2-14-11.5-24.3-25-20zm14.7 21.7c-1 5.1-6.4 8.4-11.3 8.9-3.2.3-5-.7-5.9-2.6 2-1.8 2.7-5.1.1-7.4l-.3-.3c0-1.5-.6-2.7-1.5-3.5.2-3.5 4.9-6.5 8.2-7.6 7.6-2.4 11.9 6.2 10.7 12.5zm44.1-28.1c-11.8-.9-27.1 7.8-24.8 19.9-.5.8-.8 1.9-.6 3.1 1.4 11.3 8.4 21.3 21 19.4 10.1-1.5 19.8-9.5 22.7-19.4 3.5-11.6-6.8-22.2-18.3-23zm7.9 22.4c-2.3 4.8-7.8 9.1-13.1 10.1-5.4 1-8.2-2.2-9.6-6.8 1.3-1.5 1.8-3.7.5-5.9-4.5-7.4 11.1-11.2 16-9.5 5.9 2.1 8.8 6.7 6.2 12.1z"
    />
  </svg>
)